import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Dropdown, Menu, Drawer, Button, Space, notification } from "antd";
import Pagination from "@mui/material/Pagination";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faEllipsis, faInfoCircle, faRecycle } from '@fortawesome/free-solid-svg-icons';

import TobNavBar from "../../DashBaord/Top_navbar";

import { useNavigate } from "react-router-dom";

import moment from "moment";
import SkeltonList from "../../../components/SkeltonEffect/list";
import {
  list,
  reverseTxn
} from "../../../controllers/transactionController";
import { getPage } from "../../../controllers/common";

import {
  list as getUserList,
} from "../../../controllers/V1/customerDue/dueController";
import ExportPopup from './Export';

function VendorList(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

VendorList.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {


  const [isFilterShow, setFilterShow] = useState(false);
  const handleFilterDrawer = () => setFilterShow(!isFilterShow);

  const [isExportShow, setExportShow] = useState(false);
  const handleExportDrawer = () => setExportShow(!isExportShow);

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  /************************************************************************************* */
  const [isLoading, setIsLoading] =useState(false);
  const targetRef = useRef(null);
  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [ALLLISTDATA, setListData] = useState([]);
  const [TOTALPAGES, setTotalPages] = useState(1);
  const [LIMIT, setLimit] = useState(10);
  const [SKIP, setSkip] = useState(0);
  const [filter, setFilter] = useState({
    from: "",
    to: new Date(),
    filter_by: "",
    search: "",
  }); //End

  const [showRequest, setShowRequest] = useState("");
  const [searchUser, setSearchUser] = useState({});

  const [USER_ID, setUserId] = useState("");
  


  /*********************************************************
   *  This function is use to fetch vendor list
   *********************************************************/
  const getList = async (userId = "") => {
    try {
      setIsLoading(true);
      setListData([]);
      const options = {
        type: "",
        condition: {
          $or : [
            {credit_user : userId},
            {debit_user : userId},
            // {created_by_users_id : userId},
          ],
          ...(filter?.filter_by === 'name'?{name : { $regex: filter?.search, $options: "i" } }:null),
          ...(filter?.filter_by === 'store'?{store : { $regex: filter?.search, $options: "i" } }:null),
          ...(filter?.filter_by === 'users_mobile'?{users_mobile : filter?.search }:null),
          ...(filter?.filter_by === 'due_amount'?{due_amount : filter?.search }:null),
          ...(filter?.filter_by === 'bind_person_name'?{bind_person_name : { $regex: filter?.search, $options: "i" } }:null),
          ...(filter?.filter_by === 'bind_person_id'?{bind_person_id : filter?.search }:null),
          ...(showRequest ? { status: showRequest } : null),
        },
        select: {},
        sort: { _id: -1 },
        skip: SKIP ? SKIP : 0,
        limit: LIMIT ? LIMIT : 10,
      };
      const listData = await list(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          setListData(listData?.result);
          setTotalPages(getPage(listData?.count))
        } else {
          setListData([]);
          setTotalPages(getPage(1))
        }
      } else {
        setListData([]);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }; //End

  /*********************************************************
   *  This function is for handle page change
   *********************************************************/
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    setSkip((newPage - 1) * LIMIT);
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
  };

  /*********************************************************
   *  This function is ued for handle filter input change
   *********************************************************/
  const handleFilterReset = () => {
    try {
      setFilter('');
      inputRef1.current.value = '';
      inputRef2.current.value = '';
      inputRef3.current.value = '';
      inputRef4.current.value = '';
    } catch (error) {
      
    }
  }

  const handleFilterApply = (e) => {
    try {
      e.preventDefault();
      const form = new FormData(e.target);
      setFilter((pre)=>({
        ...pre,
        'filter_by' : form.get('filter_by') || '',
        'search'    : form.get('search') || '',
        'to'        : form.get('to_date') || '',
        'from'      : form.get('from_date') || '',

      }))
      // console.log('filter',filter);
      // alert('submit');
      handleFilterDrawer();
      setSkip(0);
    } catch (error) {
      
    }
  }

  const handleSearch = async () =>{
    try {
      setIsLoading(true);
      const { searchField, searchText } = searchUser;
      const options = {
        type : "single",
        condition : { 
          ...(searchField === 'users_email' && {last_name : { $regex: searchText, $options: "i" }}),
          ...(searchField === 'store_name' && {store_name : { $regex: searchText, $options: "i" }}),
          ...(searchField === 'users_mobile' && {users_mobile : parseInt(searchText)}),
         }
      }
      const res = await getUserList(options);
      if(res?.status === true){
        setUserId(res?.result?._id || '');
        getList(res?.result?._id || '');
      }
    } catch (error) {
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  }

  /*********************************************************
   *  This function will load when page load and with dependency update
   *********************************************************/
  useEffect(() => {
    if(USER_ID){
      getList(USER_ID);
    }
    targetRef.current.scrollIntoView({
      behavior:'smooth',
    });
    document.title = "K-Winn CRM || Transaction History";
  }, [currentPage, showRequest, filter]);

  const handleReverseAmount = async (id) => {
    try {
      const res = await reverseTxn({txn_id : id});
      if(res?.status === true){
        notification.open({
            message: "Success",
            description: `Amount Reverse successfully.`,
            placement: "topRight",
            icon: <FontAwesomeIcon style={{ color: "green" }} icon={faCheckCircle} />,
            duration: 2,
        });
      } else{
        notification.open({
            message: "Oops!",
            description: `${res?.message}`,
            placement: "topRight",
            icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
            duration: 2,
        });
      }
    } catch (error) {
      notification.open({
          message: "Oops!",
          description: `Something when wrong! Please try again.`,
          placement: "topRight",
          icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
          duration: 2,
      });
    }
  }

  return (
    <>
      <div className="container-fluid" ref={targetRef}>
        <TobNavBar title={"Transaction History"}></TobNavBar>
        <div className="inventory_tabs_main_div">
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <div className="row">
                  <div className="inventory_all_tabs">
                    <div className="all_tabs_value">
                      <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="basic tabs example"
                        className="item_tabs_main_container"
                      >
                        <Tab
                          label="All"
                          className="tabs_main_contnet"
                          {...a11yProps(0)}
                          onClick={() => setShowRequest("")}
                        />
                      </Tabs>
                    </div>
                    
                    <div className="fa_filter_rating_review filter_img_and_add_btn_main">
                      {/* <div className="inventory_filter_div" onClick={handleFilterDrawer}>
                        <FontAwesomeIcon icon={faFilter} />
                        <Link
                          to={false}
                          className="filter_btn_invontry_rating_review"
                        >
                          Filter
                        </Link>
                      </div> */}

                      {/* <div className="inventory_filter_div" onClick={handleExportDrawer}>
                        <FontAwesomeIcon icon={faCloudDownload} />
                        <Link
                          to={false}
                          className="filter_btn_invontry_rating_review"
                        >
                          Export
                        </Link>
                      </div> */}

                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="inventory_all_tabs">
                    <div className="form-group col-lg-2 col-md-2 col-sm-6 col-xs-12">
                      <select name="searchField" id="searchField" className="form-control store_input_field" onChange={(e)=>setSearchUser((pre)=>({...pre, searchField : e.target.value}))}>
                        <option value="" selected disabled>Select Fields</option>
                        <option value={`store_name`}>Store Name</option>                        
                        <option value={`users_mobile`}>Mobile</option>
                        <option value={`users_email`}>Email</option>
                      </select>
                    </div>
                    <div className="form-group col-lg-6 col-md-6 col-sm-6 col-xs-12">
                      <input type="text" name="searchText" id="searchText" placeholder="Search" className="form-control store_input_field" onChange={(e)=>setSearchUser((pre)=>({...pre, searchText : e.target.value}))} />
                    </div>
                    <div className="form-group col-lg-2 col-md-2 col-sm-6 col-xs-12">
                      <button type="button" className="btn btn-danger" onClick={handleSearch}>Search</button>
                    </div>
                    <div className="form-group col-lg-2 col-md-2 col-sm-6 col-xs-12">
                      <button type="button" className="btn btn-light" onClick={handleExportDrawer}>Export</button>
                    </div>
                </div>
              </div>
            </Box>            
            <VendorList 
              >
              <div>
                <div id="content-wrapper" className="d-flex flex-column">
                  <div className="card shadow mb-4">
                    <div className="card-body pt-0">
                      <div className="table-responsive">
                        <table
                          className="table table-bordered"
                          id="dataTable"
                          width="100%"
                          cellspacing="0"
                        >
                          <thead>
                            <tr>
                              <th>Sl. No.</th>
                              <th>User's Details</th>                              
                              <th>Before Amount</th>
                              <th>Amount</th>
                              <th>After Amount</th>
                              <th>Narration</th>
                              <th>Record Type</th>
                              <th>From</th>
                              <th>Created At</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {ALLLISTDATA?.length > 0 ? (
                              ALLLISTDATA.map((items, index) => (
                                <>
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td className="admin_user_list_date">
                                      {items?.record_type === 'Credit' ? (
                                        <>
                                          {items?.credit_user?.store_name && (
                                            <span>Store: {items?.credit_user?.store_name}<br /></span>
                                          )}
                                          {items?.credit_user?.users_name && (
                                            <span>Name: {items?.credit_user?.users_name} {items?.credit_user?.last_name}<br /></span>
                                          )}
                                          {items?.credit_user?.users_email && (
                                            <span>Email: {items?.credit_user?.users_email}<br /></span>
                                          )}
                                          {items?.credit_user?.users_mobile && (
                                            <span>Mobile: {items?.credit_user?.users_mobile}<br /></span>
                                          )}
                                        </>
                                      ) : (<>
                                          {items?.debit_user?.store_name && (
                                            <span>Store: {items?.debit_user?.store_name}<br /></span>
                                          )}
                                          {items?.debit_user?.users_name && (
                                            <span>Name: {items?.debit_user?.users_name} {items?.debit_user?.last_name}<br /></span>
                                          )}
                                          {items?.debit_user?.users_email && (
                                            <span>Email: {items?.debit_user?.users_email}<br /></span>
                                          )}
                                          {items?.debit_user?.users_mobile && (
                                            <span>Mobile: {items?.debit_user?.users_mobile}<br /></span>
                                          )}
                                      </>)}
                                    </td>
                                    <td>{items?.before_amount || '0'}</td>
                                    <td>{items?.amount || '0'}</td>
                                    <td>{items?.after_amount || '0'}</td>
                                    <td>{items?.narration || '-'}</td>
                                    <td>
                                      {items?.record_type === 'Credit' ? (
                                        <button className="btn btn-success">{items?.record_type}</button>
                                      ) : (<button className="btn btn-danger">{items?.record_type}</button>)}
                                    </td>
                                    <td>
                                      {items?.from_user?.store_name && (
                                        <span>Store: {items?.from_user?.store_name}<br /></span>
                                      )}
                                      {items?.from_user?.users_name && (
                                        <span>Name: {items?.from_user?.users_name} {items?.from_user?.last_name}<br /></span>
                                      )}
                                      {/* {items?.from_user?.users_email && (
                                        <span>Email: {items?.from_user?.users_email}<br /></span>
                                      )} */}
                                      {items?.from_user?.users_mobile ? (
                                        <span>Mobile: {items?.from_user?.users_mobile}<br /></span>
                                      ):( items?.created_by_users_type )}
                                    </td>
                                    <td className="admin_user_list_date">{moment(items?.createdAt).format('DD-MM-YYY HH:mm')}</td>
                                    {/* <td className="admin_user_list_date">{moment(items?.updatedAt).format('DD-MM-YYY h:mm A')}</td> */}
                                    {items?.is_reverse === 'N' ? (
                                      <td>
                                        <Dropdown
                                          overlay={
                                            <Menu>
                                              <Menu.Item key={`01`} onClick={() => handleReverseAmount(items?._id) } >
                                                <FontAwesomeIcon icon={faRecycle} /> <span className="show_span">Reverse</span>
                                              </Menu.Item>
                                            </Menu>
                                          }
                                          placement="bottomLeft"
                                          arrow
                                        >
                                          <FontAwesomeIcon icon={faEllipsis} /> 
                                        </Dropdown>
                                      </td>
                                    ):(
                                      <td>Reversed</td>
                                    )}
                                  </tr>
                                </>
                              ))
                            ) : isLoading ? <SkeltonList row={10} col={7} /> : <tr> 
                                <td colspan="9" className="img-center" >No data found !</td> 
                            </tr>}
                          </tbody>
                        </table>
                        <div className="table_pagination_sales_order">
                          <Pagination
                            count={TOTALPAGES}
                            onChange={handlePageChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </VendorList>
          </Box>
        </div>
      </div>
      
      {/* Export*/}
      <ExportPopup popUpOpen={isExportShow} togglePopUp={handleExportDrawer} user_id={USER_ID || ''} />
      {/* Filter */}
      <Drawer
        title="Filter"
        placement={`right`}
        width={500}
        onClose={handleFilterDrawer}
        open={isFilterShow}
        extra={
          <Space>
            <Button onClick={handleFilterDrawer}>Cancel</Button>
            <Button type="primary" onClick={handleFilterReset}  style={{ backgroundColor: 'red', color: 'white' }}>
              Reset
            </Button>
          </Space>
        }
      >
        <div className="responsive">
          <div className="row">
            <form id='filter_form' onSubmit={handleFilterApply}>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  Search Field :
                </label>
                <select name="filter_by" className="form-control store_input_field" id="filter_by" ref={inputRef1}>
                  <option value=''>Select search field</option>
                  <option value='name' selected={filter?.filter_by ==='name'?true:false}>Name</option>
                  <option value='store' selected={filter?.filter_by ==='store'?true:false}>Store name</option>
                  <option value='users_mobile' selected={filter?.filter_by ==='users_mobile'?true:false}>Mobile</option>
                  <option value='due_amount' selected={filter?.filter_by ==='due_amount'?true:false}>Amount</option>
                  <option value='bind_person_name' selected={filter?.filter_by ==='bind_person_name'?true:false}>Bind with user's name</option>
                  <option value='bind_person_id' selected={filter?.filter_by ==='bind_person_id'?true:false}>Bind with user's id</option>
                </select>
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  Search Text :
                </label>
                <input
                  title="Enter search text."
                  placeholder="Enter search text."
                  type="text"
                  name="search"
                  className="form-control store_input_field"
                  id="search"  
                  ref={inputRef2}
                />
              </div>
              <br/>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <button
                  title="Enter search text."
                  type="submit"
                  className="form-control btn btn-black"    
                  style={{ backgroundColor: "black", color: "white" }}           
                >Apply</button>
              </div>
            </form>
          </div>
        </div>
      </Drawer>
    </>
  );
}
